import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CustomErrorComponent } from './custom-error.component'

@NgModule({
  declarations: [CustomErrorComponent],
  exports: [CustomErrorComponent],
  imports: [CommonModule]
})
export class CustomErrorModule {}
